import { render, staticRenderFns } from "./FeaturesSteps.vue?vue&type=template&id=29a615b9"
import script from "./FeaturesSteps.vue?vue&type=script&lang=js"
export * from "./FeaturesSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports